import React from "react";
import { sanitiseString, concatStringFromClassesArrayList } from "../../Utils";

export interface Props {
  id: string;
  navPosition?: "left" | "right";
  navigation: {
    children: any;
    classes?: string;
  };
  content: {
    children: any;
    classes?: string;
  };
  dataTestId: string;
}

export const NavigationAndContentLayout = (props: Props) => {
  const classListNav = {
    defaultClass: "ons-grid__col ons-col-4@l",
    optionalClasses: [
      props.navigation.classes ? props.navigation.classes : null,
    ],
  };
  const classNameNav = concatStringFromClassesArrayList(classListNav);

  const classListContent = {
    defaultClass: "ons-grid__col ons-col-8@l",
    optionalClasses: [props.content.classes ? props.content.classes : null],
  };
  const classNameContent = concatStringFromClassesArrayList(classListContent);

  const sanitisedDataTestId = sanitiseString(props.dataTestId);
  const navWriteOut = (
    <div className={classNameNav} data-testid={`${sanitisedDataTestId}-nav`}>
      {props.navigation.children}
    </div>
  );
  return (
    <div
      className="ons-grid"
      id={sanitiseString(props.id)}
      data-testid={sanitisedDataTestId}
    >
      {(props.navPosition === "left" || props.navPosition === undefined) &&
        navWriteOut}
      <div
        className={classNameContent}
        data-testid={`${sanitisedDataTestId}-content`}
      >
        {props.content.children}
      </div>
      {props.navPosition === "right" && navWriteOut}
    </div>
  );
};
